export default "__VITE_ASSET__6e48c854__"